// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Cancel = function Cancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cancel-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.043 16.371 3.629 4.957A8.1 8.1 0 0 0 1.875 10 8.124 8.124 0 0 0 10 18.125c1.906 0 3.66-.656 5.043-1.754m1.324-1.324A8.1 8.1 0 0 0 18.125 10 8.124 8.124 0 0 0 10 1.875c-1.906 0-3.66.656-5.043 1.754l11.414 11.414zM0 10a10 10 0 1 1 20 0 10 10 0 0 1-20 0"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cancel-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
